/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Study_Bioinformatics19Inputs */

const en__field_enum_study_bioinformatics19 = /** @type {(inputs: _Field_Enum_Study_Bioinformatics19Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bioinformatics`)
};

const de__field_enum_study_bioinformatics19 = /** @type {(inputs: _Field_Enum_Study_Bioinformatics19Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bioinformatik`)
};

/**
* | output |
* | --- |
* | "Bioinformatics" |
*
* @param {_Field_Enum_Study_Bioinformatics19Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_study_bioinformatics19 = /** @type {((inputs?: _Field_Enum_Study_Bioinformatics19Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Study_Bioinformatics19Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_study_bioinformatics19(inputs)
	return de__field_enum_study_bioinformatics19(inputs)
});
export { _field_enum_study_bioinformatics19 as "_field_enum_STUDY_BIOINFORMATICS" }